if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.price = this.form.querySelector('.product-variant-price').value;
      this.email = this.form.querySelector('.product-customer-email').value;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.handleRecommendation();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
  
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if(this.submitButton.classList.contains('direct_checkout_btn')){
              window.location.href = window.location.origin+'/cart/'+response.id+':'+response.quantity;
            }else{
               this.cart.renderContents(response);
            }
           
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if(!this.submitButton.classList.contains('direct_checkout_btn')){
            this.submitButton.classList.remove('loading');
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if(!this.submitButton.classList.contains('direct_checkout_btn')){
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');          
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }

          // window.criteo_q = window.criteo_q || [];
          // var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
          // window.criteo_q.push(
          //   { event: "setAccount", account: 15858},
          //   { event: "setEmail", email: this.email },
          //   { event: "setSiteType", type: deviceType},
          //   { event: "addToCart", item: [
          //     {id: formData.get('id'), price: this.price, quantity: formData.get('quantity') }
          //   ]}
          // );
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    handleRecommendation() {
        var recommendedSelects = document.querySelectorAll('[js-recommendation-select]')
  
        var recommendedButtons = document.querySelectorAll('[js-recommendation-button]')



        if(recommendedSelects.length) {
          recommendedSelects.forEach(function(select){
              select.addEventListener('change', function(evt){

                  var currentSelect = this;
                  var selectedVariantId = this.value;
                  var nearestParent = this.closest('.product-recommendation__information');
                  var nearestButton = nearestParent.querySelector('[js-recommendation-button]');

                  nearestButton.dataset.variantId = selectedVariantId;

                  if(nearestButton.dataset.variantId != 'NULL') {
                    nearestButton.disabled = false;
                  }
              })
          })
        }

        var that = this

        if(recommendedButtons.length) {
          recommendedButtons.forEach(function(button){
            button.addEventListener('click', function(evt){
                evt.preventDefault();
                var variantId = this.dataset.variantId 
                var nearestParent = this.closest('.product-recommendation__information');
                var nearestForm = nearestParent.querySelector('form');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(nearestForm);
                formData.append('id', variantId)
                
                if (that.cart) {
                  formData.append('sections', that.cart.getSectionsToRender().map((section) => section.id));
                  formData.append('sections_url', window.location.pathname);
                  that.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;
          
                
                fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
                      that.handleErrorMessage(response.description);
          
                      const soldOutMessage = that.submitButton.querySelector('.sold-out-message');
                      if (!soldOutMessage) return;
                      that.submitButton.setAttribute('aria-disabled', true);
                      that.submitButton.querySelector('span').classList.add('hidden');
                      soldOutMessage.classList.remove('hidden');
                      that.error = true;
                      return;
                    } else if (!that.cart) {
                      window.location = window.routes.cart_url;
                      return;
                    }
          
                    if (!that.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
                    that.error = false;
                    const quickAddModal = that.closest('quick-add-modal');
                    if (quickAddModal) {
                      document.body.addEventListener('modalClosed', () => {
                        setTimeout(() => { that.cart.renderContents(response) });
                      }, { once: true });
                      quickAddModal.hide(true);
                    } else {
                      if(that.submitButton.classList.contains('direct_checkout_btn')){
                        window.location.href = window.location.origin+'/cart/'+response.id+':'+response.quantity;
                      }else{
                         that.cart.renderContents(response);
                      }
                     
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {
                    if(!that.submitButton.classList.contains('direct_checkout_btn')){
                      that.submitButton.classList.remove('loading');
                    }
                    if (that.cart && that.cart.classList.contains('is-empty')) that.cart.classList.remove('is-empty');
                    if(!that.submitButton.classList.contains('direct_checkout_btn')){
                      if (!that.error) that.submitButton.removeAttribute('aria-disabled');          
                      that.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    }
                  });
                  
            })
        })
        }

    }
  });


}
